/**
 * Globo Swatch Fallback
 * If CDN swatch image fails to load (404), swap to the original Globo swatch image.
 */
(function () {
    function checkSwatchImages(root) {
        const swatches = (root || document).querySelectorAll('.spf-product__swatch-image[data-fallback-swatch]');
        swatches.forEach(function (el) {
            if (el.dataset.swatchChecked) return;
            el.dataset.swatchChecked = '1';

            const style = el.style.backgroundImage;
            const match = style.match(/url\(['"]?(.*?)['"]?\)/);
            if (!match || !match[1]) return;

            const img = new Image();
            img.onload = function () { /* CDN image exists, do nothing */ };
            img.onerror = function () {
                const fallback = el.getAttribute('data-fallback-swatch');
                if (fallback) {
                    el.style.backgroundImage = "url('" + fallback + "')";
                }
            };
            img.src = match[1];
        });
    }

    // Initial check
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { checkSwatchImages(); });
    } else {
        checkSwatchImages();
    }

    // Re-check after Globo filter re-renders
    window.addEventListener('globoFilterRenderCompleted', function () {
        setTimeout(function () { checkSwatchImages(); }, 300);
    });

    // Observe DOM for dynamically added swatches
    var observer = new MutationObserver(function (mutations) {
        var hasNewSwatches = mutations.some(function (m) {
            return m.addedNodes.length > 0;
        });
        if (hasNewSwatches) checkSwatchImages();
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
})();
